import React from 'react';
import PropTypes from 'prop-types';
import { createSsrJs } from './layoutFixerEmbededJs';
export var LayoutFixer = function (props) {
    try {
        return (React.createElement("div", { id: 'layout-fixer-' + props.id + props.isPrerenderMode, key: 'layout-fixer-' + props.id + props.isPrerenderMode, style: { display: 'none' } },
            React.createElement("link", { rel: "stylesheet", id: 'layout-fixer-style-' + props.id }),
            React.createElement("script", { dangerouslySetInnerHTML: {
                    __html: "try {\n            window.requestAnimationFrame(function() {\n              ".concat(createSsrJs(props), "\n        } catch (e) {\n          console.warn('Cannot set layoutFixer css', e);\n        }"),
                } })));
    }
    catch (e) {
        return (React.createElement("div", { id: "layoutFixerErrors", style: { display: 'none' } }, e.toString()));
    }
};
LayoutFixer.propTypes = {
    isPrerenderMode: PropTypes.bool,
    id: PropTypes.string,
    items: PropTypes.array,
    options: PropTypes.object,
    useNativeLayoutFixer: PropTypes.bool,
};
//# sourceMappingURL=layoutFixer.js.map